import { BACKEND_URL } from '../config';
import * as RestService from './RestService';

const BASE_URL = BACKEND_URL + '/auth/knockout-phases';
const BASE_PORTAL_URL = BACKEND_URL + '/auth/portal-knockout-phases';

export interface IKnockoutPhaseDTO {
  phaseNum?: number;
  name?: string;
}

export const updateKnockoutPhaseName = (groupId: number, phaseNum: number, data: IKnockoutPhaseDTO) => {
  return RestService.put(`${BASE_URL}/${groupId}/${phaseNum}`, data);
};

export const updateKnockoutPhaseNames = (groupId: number, data: IKnockoutPhaseDTO[]) => {
  return RestService.put(`${BASE_URL}/${groupId}`, data);
};

export const deleteKnockoutPhaseName = (groupId: number, phaseNum: number) => {
  return RestService.delete(`${BASE_URL}/${groupId}/${phaseNum}`);
};

export const findPortalPhasesOrdered = (totalPhases: number) => {
  return RestService.get(`${BASE_PORTAL_URL}/ordered?totalPhases=${totalPhases}`);
};